<div class="pdf-report-dialog">
    <!-- Header Banner -->
    <div class="dialog-header">
        <mat-icon class="header-icon">list_alt</mat-icon>
        <span class="header-title">Request PDF Project Report</span>
    </div>

    <!-- Main Content Area (Pre-submission) -->
    <div mat-dialog-content class="dialog-content" *ngIf="!requestSent">
        <!-- Mode Switch (Create New vs Add to Existing) -->
        <div class="mode-selection">
            <label class="radio-label">
                <input type="radio" name="reportMode" [checked]="newReport" (change)="onModeChange(true)">
                <span class="radio-text">Create New Report</span>
            </label>
            <label class="radio-label">
                <input type="radio" name="reportMode" [checked]="!newReport" (change)="onModeChange(false)">
                <span class="radio-text">Add to existing Report</span>
            </label>
        </div>

        <!-- Form Rows -->
        <div class="form-grid">
            <!-- Title Row -->
            <div class="form-row">
                <label class="form-label" for="reportTitleInput">
                    Title <span class="mandatory">*</span>
                </label>
                <div class="form-control-cell">
                    <input *ngIf="newReport" id="reportTitleInput" type="text" class="form-input" maxlength="50"
                        [ngModel]="title" (ngModelChange)="onTitleChange($event)" required>

                    <div *ngIf="!newReport" class="select-wrapper">
                        <select id="reportSelect" class="form-select" [ngModel]="selectedReportGuid"
                            (ngModelChange)="onReportSelected($event)">
                            <option [ngValue]="null" disabled selected>
                                {{ isLoadingReports ? 'Loading reports...' : 'Select Existing Report Name' }}
                            </option>
                            <option *ngFor="let r of reports" [value]="getReportKey(r)">
                                {{ getReportTitle(r) }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            <!-- Description Row -->
            <div class="form-row">
                <label class="form-label" for="reportDescriptionInput">
                    Description
                </label>
                <div class="form-control-cell">
                    <textarea *ngIf="newReport" id="reportDescriptionInput" class="form-textarea" rows="2"
                        maxlength="500" [(ngModel)]="description"></textarea>
                    <div *ngIf="!newReport" class="readonly-display">
                        {{ description || '-' }}
                    </div>
                </div>
            </div>

            <!-- File Name Row -->
            <div class="form-row">
                <label class="form-label" for="reportFileNameInput">
                    File name <span *ngIf="newReport" class="mandatory">*</span>
                </label>
                <div class="form-control-cell">
                    <div *ngIf="newReport" class="filename-input-container">
                        <input id="reportFileNameInput" type="text" class="form-input filename-input" maxlength="54"
                            [ngModel]="fileName" (ngModelChange)="onFileNameChange($event)" required>
                        <span class="file-suffix">.pdf</span>
                    </div>
                    <div *ngIf="!newReport" class="readonly-display">
                        {{ fileName || '-' }}
                    </div>
                </div>
            </div>

            <!-- Run Immediately Row -->
            <div class="form-row run-immediately-row" *ngIf="newReport">
                <div class="form-label"></div>
                <div class="form-control-cell">
                    <label class="checkbox-label">
                        <input type="checkbox" [(ngModel)]="runImmediately">
                        <span class="checkbox-text">Run Report Immediately</span>
                    </label>
                </div>
            </div>
        </div>

        <!-- Content Fieldset (Create New mode only) -->
        <fieldset class="content-fieldset" *ngIf="newReport">
            <legend class="content-legend">Content</legend>

            <!-- Project Notes Duration -->
            <div class="notes-duration-section">
                <div class="section-subheading">Project Notes:</div>
                <div class="duration-options">
                    <label class="duration-radio-label">
                        <input type="radio" name="projectNotesDuration" [value]="-1" [(ngModel)]="projectNotesDuration">
                        <span>All</span>
                    </label>
                    <label class="duration-radio-label">
                        <input type="radio" name="projectNotesDuration" [value]="0" [(ngModel)]="projectNotesDuration">
                        <span>None</span>
                    </label>
                    <label class="duration-radio-label custom-months-row">
                        <input type="radio" name="projectNotesDuration" [value]="1" [(ngModel)]="projectNotesDuration">
                        <span>Notes added within the last </span>
                        <input type="number" min="1" class="months-number-input" [(ngModel)]="createdWithinMonths"
                            [disabled]="projectNotesDuration !== 1">
                        <span> months.</span>
                    </label>
                </div>
            </div>

            <!-- Note Types Grid -->
            <div class="note-types-section">
                <div class="section-subheading">Note Types:</div>
                <div class="note-types-grid">
                    <div class="note-types-row">
                        <label class="note-type-label" *ngFor="let nt of noteTypes.slice(0, 3)">
                            <input type="checkbox" [(ngModel)]="nt.selected">
                            <span>{{ nt.label }}</span>
                        </label>
                    </div>
                    <div class="note-types-row">
                        <label class="note-type-label" *ngFor="let nt of noteTypes.slice(3, 6)">
                            <input type="checkbox" [(ngModel)]="nt.selected">
                            <span>{{ nt.label }}</span>
                        </label>
                    </div>
                </div>
            </div>
        </fieldset>
    </div>

    <!-- Post-submission Result Area -->
    <div mat-dialog-content class="dialog-content result-content" *ngIf="requestSent">
        <div *ngIf="success" class="success-message">
            Your Report Request has been placed on the queue. You will be notified by email when your report is ready for download.
        </div>
        <div *ngIf="!success" class="error">
            {{ error }}
        </div>
    </div>

    <!-- Actions / Footer -->
    <div mat-dialog-actions align="end" class="dialog-actions">
        <ng-container *ngIf="!requestSent">
            <button mat-button type="button" class="action-btn-cancel" (click)="cancel()">
                Cancel
            </button>
            <button mat-raised-button color="primary" type="button" class="action-btn-submit"
                [disabled]="isSubmitDisabled" (click)="submit()">
                {{ submitButtonCaption }}
            </button>
        </ng-container>

        <ng-container *ngIf="requestSent">
            <button mat-raised-button color="primary" type="button" class="action-btn-close" (click)="close()">
                OK
            </button>
        </ng-container>
    </div>
</div>